import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import LoginRegister from '../LoginRegister';
const UserCreateModal = ({isUserCreateModalOpen, handleIsUserCreateModalOpenToggle, isCheckout, domainName, domainId,  onDomainUsersUpdate, handleUpdateUserFromProfile}) => {

   


    return (
      <MDBModal tabIndex={-1} staticBackdrop={true} closeOnEsc={true} open={isUserCreateModalOpen} >
               <MDBModalDialog   size="lg" >
          <MDBModalContent style={{ height: '0vh' }}>
          
            <MDBModalBody><LoginRegister isCreate={true}  isCheckout={isCheckout} domainName={domainName} domainId = {domainId}   handleIsUserCreateModalOpenToggle={handleIsUserCreateModalOpenToggle}   onDomainUsersUpdate={onDomainUsersUpdate} handleUpdateUserFromProfile={handleUpdateUserFromProfile}/></MDBModalBody>

          </MDBModalContent>
        </MDBModalDialog>
            </MDBModal>
    );
};
UserCreateModal.propTypes = {
      handleIsUserCreateModalOpenToggle: PropTypes.func,
      domainId: PropTypes.string,
      isUserCreateModalOpen: PropTypes.bool,
      isCheckout: PropTypes.bool,
    domainName: PropTypes.string,
    onDomainUsersUpdate: PropTypes.func,
    handleUpdateUserFromProfile: PropTypes.func,
}


export default UserCreateModal;
